import Vue from 'vue'
import axios  from 'axios'
import router from '../router'
axios.defaults.timeout = 25000;
// axios.defaults.baseURL="http://192.168.0.92:2889/api" 
axios.defaults.baseURL="/api"
//拦截器
axios.interceptors.request.use(
  config => {
	  let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
	  let token = ''
	  if(userInfo){
		  token = userInfo.token_type + ' ' + userInfo.access_token;
	  }
    config.data = JSON.stringify(config.data);
    config.headers = {
      'Content-Type':'application/json;charset=UTF-8',
			'Blade-Auth': token,
			'Authorization': 'Basic dXNlcjp1c2VyX3NlY3JldA=='
    }
   
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);
axios.interceptors.response.use(
  response => {
    if(response.data.errCode ==2){
      router.push({
        path:"/login",
        querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
      })
    }
    return response;
  },
  error => {
    return Promise.reject(error)
  }
)
//get请求
export function get(url,params={}){
  return new Promise((resolve,reject) => {
    axios.get(url,{
      params:params
    })
    .then(response => {
			if(response.data.code == 400){
				sessionStorage.removeItem('userInfo');
				router.push({
				  path:"/",
				  querry:{}//从哪个页面跳转
				})
			}else{
				resolve(response.data);
			}
    })
    .catch(err => {
      reject(err)
    })
  })
}
//post请求
export function post(url,data = {}){
   return new Promise((resolve,reject) => {
     axios.post(url,data)
			.then(response => {
				if(response.data.code == 400){
					sessionStorage.removeItem('userInfo');
					router.push({
					  path:"/",
					  querry:{}//从哪个页面跳转
					})
				}else{
					resolve(response.data);
				}
			},err => {
				reject(err)
			})
   })
}
//delete请求
export function deletefn(url,params={}){
  return new Promise((resolve,reject) => {
    axios.delete(url,{
      params:params
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(err => {
      reject(err)
    })
  })
}
Vue.prototype.$ajax = axios
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$deletefn = deletefn


// WEBPACK FOOTER //
// ./src/axios/index.js